<template>
  <div class="links">
    <Header headertext="リンク" />
    <b-container class="bv-example-row">
      <b-row>
        <div class="mt-3" v-for="item of items" :key="item.name">
          <b-card :title="item.name">
            <b-card-text>
              {{ item.text }}
            </b-card-text>
            <a :href="item.url" class="card-link">移動</a>
          </b-card>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "links",
  components: {
    Header,
  },
  data() {
    return {
      items: [
        {
          name: "ブーログ",
          text: "プログラミングの話題が中心のブログです。",
          url: "https://ambiesoft.com/blog",
        },
        {
          name: "EverydayTask",
          text: "毎日やるべきタスクを登録して確認することができるウェブアプリです。",
          url: "https://ambiesoft.com/everydaytask/",
        },
        {
          name: "🛒買い物いくら？🛒",
          text: "スーパーマーケットなどでお買い物中に支払い金額を確認するためのアプリです",
          url: "https://ambiesoft.com/kaimonoikura/",
        },
        {
          name: "C++プログラマのためのC++/CLI入門",
          text: "マイナーな言語であるC++/CLIの解説ページです。",
          url: "https://ambiesoft.com/cppcli",
        },
        {
          name: "偉大ブログ",
          text: "時事ネタのブログです。",
          url: "https://ambiesoft.com/minerva",
        },
        {
          name: "Github",
          text: "レポジトリサイト",
          url: "https://github.com/",
        },
        {
          name: "Stimula",
          text: "英単語学習サイト",
          url: "https://ambiesoft.com/stimula",
        },
        {
          name: "英中・中英辞典",
          url: "https://ambiesoft.com/dict",
        },
        {
          name: "掲示板",
          url: "https://ambiesoft.com/minibbs/minibbs.php",
        },
      ],
    };
  },
};
</script>

<style scoped>
.links {
  text-align: center;
}
#error {
  color: red;
}

#header {
  margin-left: 20px;
  margin-right: 20px;
}
</style>